import { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { DashboardContext } from "../../../../contexts/Dashboard/DashboardContext";

const ModalConfirmation = ({
  show,
  changeModal,
}: {
  show: boolean;
  changeModal: (arg0: boolean) => void;
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { save } = useContext(DashboardContext);

  const handleClose = () => {
    changeModal(false);
  };

  function notSave() {
    navigate(`/dashboard/view/${id}`);
  }

  function saveAndRedirect() {
    save();
  }

  return show ? (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Alterações não salvas
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Há modificações não salvas nessa página, você deseja salvá-las?
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="secondary" onClick={notSave}>
          Não salvar
        </Button>
        <Button type="button" variant="primary" onClick={saveAndRedirect}>
          Salvar e sair
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
};

export default ModalConfirmation;
